<section class="not-authorized" role="main">
  <div class="not-authorized__card">
    <nova-icon name="security" size="medium" [ariaHidden]="true" />
    <h1>{{ 'not-authorized.TITLE' | translate }}</h1>
    <p>{{ 'not-authorized.MESSAGE' | translate }}</p>
    <p class="not-authorized__hint">{{ 'not-authorized.HINT' | translate }}</p>
    <a
      class="nova-link"
      href="tel:+18449131386"
      [attr.aria-label]="'not-authorized.CALL_SUPPORT' | translate"
    >{{ phoneNumber }}</a>
  </div>
</section>
